import { useEffect, useRef, useState } from "react";
import Icon from "../Icon";
import { AG_TIPO_CLR } from "../../constants";
import { fmtFull } from "../../utils";

export default function GlobalSearch({notionItems=[],teams=[],agenda=[],q,setQ,onClose,onAbrirCuaderno}) {
  const inputRef = useRef(null);
  const [activo, setActivo] = useState(0);
  useEffect(()=>{inputRef.current?.focus();},[]);
  const lq=q.toLowerCase().trim();
  const notionResults = lq.length>1 ? notionItems.filter(t=>t.title.toLowerCase().includes(lq)).slice(0,6) : [];
  const agResults     = lq.length>1 ? agenda.filter(a=>(a.description||"").toLowerCase().includes(lq)).slice(0,4) : [];
  const hasResults    = notionResults.length||agResults.length;
  // Notion y Cuaderno en una sola lista navegable con flechas.
  const todos = [
    ...notionResults.map(item=>({ tipo:"notion", item })),
    ...agResults.map(item=>({ tipo:"cuaderno", item })),
  ];
  useEffect(()=>{ setActivo(0); },[lq]);

  const abrir = (r) => {
    if(!r) return;
    if(r.tipo==="notion"){
      window.open(r.item.url||"about:blank","_blank","noopener,noreferrer");
      onClose();
    } else {
      onAbrirCuaderno?.(r.item);
      onClose();
    }
  };

  useEffect(()=>{
    const h=e=>{
      if(e.key==="Escape"){ onClose(); return; }
      if(!todos.length) return;
      if(e.key==="ArrowDown"){ e.preventDefault(); setActivo(i=>(i+1)%todos.length); }
      else if(e.key==="ArrowUp"){ e.preventDefault(); setActivo(i=>(i-1+todos.length)%todos.length); }
      else if(e.key==="Enter"){ e.preventDefault(); abrir(todos[activo]); }
    };
    window.addEventListener("keydown",h);
    return()=>window.removeEventListener("keydown",h);
  });// eslint-disable-line

  const marca = (r) => todos[activo]===r;
  const estiloFila = (r) => ({
    padding:"10px 16px",display:"flex",alignItems:"center",gap:10,textDecoration:"none",color:"inherit",
    background: marca(r) ? "var(--accent-bg)" : "transparent", cursor:"pointer",
  });

  return (
    <div className="modal-bg" style={{position:"fixed",inset:0,background:"rgba(0,0,0,.45)",zIndex:500,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"10vh 12px 12px"}}
      onClick={onClose}>
      <div role="dialog" aria-modal="true" aria-label="Buscar" className="modal-box" style={{background:"var(--surface)",borderRadius:16,boxShadow:"var(--shadow-lg)",width:"100%",maxWidth:560,overflow:"hidden"}}
        onClick={e=>e.stopPropagation()}>
        {/* Search input */}
        <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",borderBottom:"1px solid var(--border)"}}>
          <Icon name="search" size={16} color="var(--text3)"/>
          <input aria-label="Buscar en toda la aplicación" ref={inputRef} value={q} onChange={e=>setQ(e.target.value)}
            role="combobox" aria-expanded={todos.length>0} aria-controls="busqueda-resultados"
            aria-activedescendant={todos.length?`busqueda-${activo}`:undefined}
            placeholder="Buscar en Notion, Cuaderno…"
            style={{flex:1,border:"none",outline:"none",fontSize:15,fontFamily:"var(--font)",background:"transparent",color:"var(--text)"}}/>
          {q&&<button className="btn" aria-label="Borrar búsqueda" onClick={()=>setQ("")} style={{background:"none",border:"none",cursor:"pointer",padding:2,display:"flex"}}><Icon name="x-lg" size={13} color="var(--text3)"/></button>}
          <kbd style={{fontSize:10,padding:"2px 6px",borderRadius:5,background:"var(--bg)",border:"1px solid var(--border)",color:"var(--text3)",fontFamily:"monospace"}}>ESC</kbd>
        </div>
        {/* Results */}
        {/* Tope relativo al alto real: 420px fijos se salian de un movil tumbado */}
        <div id="busqueda-resultados" role="listbox" style={{maxHeight:"min(420px, 55vh)",overflowY:"auto"}}>
          {!lq.length&&(
            <div style={{padding:"24px",textAlign:"center",color:"var(--text3)",fontSize:12}}>
              <Icon name="search" size={24} color="var(--text3)" style={{display:"block",margin:"0 auto 8px"}}/>
              Escribe para buscar en Notion y Cuaderno
            </div>
          )}
          {lq.length>0&&!hasResults&&(
            <div style={{padding:"24px",textAlign:"center",color:"var(--text3)",fontSize:12}}>Sin resultados para "{q}"</div>
          )}
          {notionResults.length>0&&(
            <>
              <div style={{padding:"8px 16px 4px",fontSize:10,fontWeight:700,color:"var(--text3)",textTransform:"uppercase",letterSpacing:".08em",background:"var(--bg)"}}>Notion</div>
              {notionResults.map((item,i)=>{
                const r = todos[i];
                return (
                  <a key={item.external_id} id={`busqueda-${i}`} role="option" aria-selected={marca(r)}
                    href={item.url||"#"} target="_blank" rel="noreferrer"
                    className="ac-item" style={estiloFila(r)}
                    onMouseEnter={()=>setActivo(i)}
                    onClick={onClose}>
                    <span style={{fontSize:16,flexShrink:0,width:20,textAlign:"center"}}>{item.icon||"📄"}</span>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:12.5,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.title}</div>
                      <div style={{fontSize:10,color:"var(--text3)",marginTop:1}}>{item.item_type==="database"?"Base de datos":"Página"}{item.status?` · ${item.status}`:""}</div>
                    </div>
                    <span style={{fontSize:10,padding:"2px 6px",borderRadius:20,background:"var(--info-bg)",color:"#0369a1",fontWeight:700,flexShrink:0}}>Notion</span>
                  </a>
                );
              })}
            </>
          )}
          {agResults.length>0&&(
            <>
              <div style={{padding:"8px 16px 4px",fontSize:10,fontWeight:700,color:"var(--text3)",textTransform:"uppercase",letterSpacing:".08em",background:"var(--bg)"}}>Cuaderno</div>
              {agResults.map((a,j)=>{
                const i = notionResults.length + j;
                const r = todos[i];
                return (
                  <div key={a.id} id={`busqueda-${i}`} role="option" aria-selected={marca(r)}
                    className="ac-item" style={estiloFila(r)}
                    onMouseEnter={()=>setActivo(i)}
                    onClick={()=>abrir(r)}>
                    <Icon name="journal-text" size={13} color={AG_TIPO_CLR[a.type]||"var(--text3)"}/>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:12.5,fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.description}</div>
                      <div style={{fontSize:10,color:"var(--text3)",marginTop:1}}>{fmtFull(a.entry_date)} · {a.type}</div>
                    </div>
                    <span style={{fontSize:11,fontWeight:700,color:"var(--accent)"}}>{a.hours}h</span>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
